import { DependencyList, useEffect } from 'react';
import useTimeoutFn from './useTimeoutFn';

export type UseDebounceReturn = [() => boolean | null, () => void];

// docs https://github.com/streamich/react-use/blob/master/docs/useDebounce.md

export default function useDebounce(
    fn: () => void,
    ms = 0,
    deps: DependencyList = []
): UseDebounceReturn {
    const [isReady, cancel, reset] = useTimeoutFn(fn, ms);

    useEffect(reset, deps);

    return [isReady, cancel];
}
